import { Component, HostListener, OnInit } from '@angular/core';
import { UserRecommendation } from '../../interfaces/user';
import { RecommendationService } from 'src/app/services/recommendation.service';
import { CmsContentService } from 'src/app/services/cms-content.service';
import { Historyitem } from '../../models/historyitem';

@Component({
  selector: 'app-design',
  templateUrl: './design.component.html',
  styleUrls: ['./design.component.scss']
})
export class DesignComponent implements OnInit {

  public width = window.innerWidth;

  public historyitem?: Historyitem;

  public recommendation1: UserRecommendation;
  public recommendation2: UserRecommendation;

  public timestamp = Date.now();
  public timestamp_now = 0;
  public timestamp_minus_one = 1;
  public timestamp_minus_ten = 22;

  constructor(public recommendationService: RecommendationService, private cms: CmsContentService) {
    this.recommendation1 = {
      viewed: Date.now().toString(),
      recommendationKey: "si_pts_recommendation_budget_1"
    }

    this.recommendation2 = {
      viewed: Date.now().toString(),
      recommendationKey: "si_pts_recommendation_budget_2"
    }

    this.recommendationService.getRecommendation("si_pts_recommendation_pause_1").subscribe((recommendation) => {
      this.recommendation1.recommendation = recommendation;
    });

    this.recommendationService.getRecommendation("si_pts_recommendation_pause_2").subscribe((recommendation) => {
      this.recommendation2.recommendation = recommendation;
    });
  }

  ngOnInit(): void {
    this.historyitem = { header: "Header", text: "Text text text text text text text text ", image: this.cms.getCategoryImageUrl("gambling-data", "money", "no-data.svg"), subitems: [], popover: "popover popover popover" };
  }

  @HostListener('window:resize')
  onResize() {
    this.width = window.innerWidth;
  }
}
